import { Injectable } from '@angular/core';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { LoginModalContent } from '../../models/aem';
import { ForgotLoginHelperService } from '../../services/forgot-login-service/forgot-login-helper.service';

@Injectable({
  providedIn: 'root'
})
export class ForgotLoginAdapterService {
  constructor(private forgotLoginHelper: ForgotLoginHelperService) {}
  async getForgotLoginContentAdapter(
    loginAemResponse: LoginModalContent,
    oauthConfig: OauthAEMConfig
  ) {
    return {
      formGroup: this.forgotLoginHelper.createLoginForm(),
      forgotLoginAttributes:
        this.forgotLoginHelper.getForgotLoginAttributes(oauthConfig),
      forgotLoginContent:
        this.forgotLoginHelper.getForgotLoginScreenContent(loginAemResponse),
      disableButton: false
    };
  }
}
